import { useMemo } from 'react'

import { CommonApplicationsProps, LogApplicationsActionsTypes } from './types'
import { modalsApplicationActions } from './utils'

type Props = {
  type: LogApplicationsActionsTypes
} & CommonApplicationsProps

export const LogApplicationsActions = ({ type, data, ...props }: Props) => {
  const Component = useMemo(() => modalsApplicationActions[type], [type])

  if (!Component) return null

  return <Component data={data} {...props} />
}
